import type { Auftrag, AuftragsTyp } from '@awf/shared';
import { gruppeVon } from './status.js';

export const SIEBEN_TAGE_MS = 7 * 24 * 60 * 60 * 1000;
/**
 * `aktualisiertAm` stempelt der Server, `jetzt` ist die Geraeteuhr. Geht sie ein wenig nach, laege
 * ein gerade fertig gewordener Lauf "in der Zukunft" und fiele aus der Zahl. Erst darueber hinaus
 * gilt ein Zeitstempel als falsch.
 */
export const UHRENVERSATZ_MS = 5 * 60 * 1000;

/** Fertig und zuletzt geaendert in den letzten 7 Tagen; Karte und Listenfilter teilen das. */
export function istFrischFertig(auftrag: Auftrag, jetzt: Date): boolean {
  if (auftrag.status !== 'fertig') return false;
  const zeitpunkt = Date.parse(auftrag.aktualisiertAm);
  if (Number.isNaN(zeitpunkt)) return false;
  const jetztMs = jetzt.getTime();
  return zeitpunkt >= jetztMs - SIEBEN_TAGE_MS && zeitpunkt <= jetztMs + UHRENVERSATZ_MS;
}

export interface Kennzahlen {
  laeuft: number;
  wartet: number;
  fertigSiebenTage: number;
}

/**
 * Aus den schon geladenen Daten, ohne eigene Abfrage (Spec C, Abschnitt 6). Folgt dem
 * Typ-Filter, aber nicht Status und Suche: die Karten SIND die Statusauswahl.
 */
export function zaehleKennzahlen(
  auftraege: readonly Auftrag[],
  typ: AuftragsTyp | 'alle',
  jetzt: Date,
): Kennzahlen {
  const ergebnis: Kennzahlen = { laeuft: 0, wartet: 0, fertigSiebenTage: 0 };
  for (const a of auftraege) {
    if (typ !== 'alle' && a.typ !== typ) continue;
    const gruppe = gruppeVon(a.status);
    if (gruppe === 'laeuft') ergebnis.laeuft += 1;
    else if (gruppe === 'wartet') ergebnis.wartet += 1;
    else if (istFrischFertig(a, jetzt)) ergebnis.fertigSiebenTage += 1;
  }
  return ergebnis;
}
